import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';

@Component({
  selector: 'app-why-multiple-select',
  template: `
      <section class="main-container">
          <section class="menu--container between">
              <article class="pd-left-22" style="height: calc(100% - 200px);">
                  <div class="mr-bottom-16">
                      <div (click)="dismiss()" class="ion-text-end">
                          <ion-icon class="icon add__color primary-shade" name="close-outline"></ion-icon>
                      </div>
                  </div>
                  <div class="add-scroll">
                      <div *ngFor="let entry of listingObj" class="pd-bottom-16 capsule">
                          <ion-checkbox class="tnc-check-box s18" [value]="entry._id"
                                        [checked]="entry.checked"
                                        [disabled]="disableCheckBox"
                                        (ionChange)="optionSelected(entry, $event)"></ion-checkbox>
                          <ion-label class="input-text-label p2 mr-left-8">{{ entry.title }}{{ entry.name }}</ion-label>
                      </div>
                  </div>
              </article>
              <article class="flex-row ion-justify-content-between mr-top-16">
                  <ion-button class="app-btn secondary half" (click)="dismiss()">
                      <span>Cancel</span>
                  </ion-button>
                  <ion-button class="app-btn primary half" (click)="applyFilter()">
                      <span>Set</span>
                  </ion-button>
              </article>
          </section>
      </section>
  `,
  styleUrls: ['./modal-page.scss']
})
export class MultipleSelectComponent implements OnInit, AfterViewInit {
  @Input() listingObj: Array<any>;
  @Input() selectedOptions: Array<any>;
  @Input() singleSelector = false;
  disableCheckBox = false;
  selectedGigs: Array<any> = [];

  constructor(public modalController: ModalController) {
  }

  ngOnInit(): void {
    let selectedList = [];
    selectedList = this.selectedOptions;
    if (selectedList.length > 0) {
      this.listingObj.forEach((listObj: any) => selectedList.forEach((selectedObj: any) => {
        // eslint-disable-next-line no-underscore-dangle
        if (selectedObj._id === listObj._id || selectedObj === listObj._id) {
          listObj.checked = true;
        }
      }));
    }
  }

  dismiss() {
    this.modalController.dismiss({
      dismissed: true
    });
  }

  applyFilter() {
    this.modalController.dismiss({
      selectedGigs: this.selectedGigs
    });
  }

  optionSelected(entry, event) {
    if (event.detail.checked) {
      this.disableCheckBox = this.singleSelector;
      // eslint-disable-next-line no-underscore-dangle
      this.selectedGigs.push(entry._id);
    } else {
      this.disableCheckBox = !!this.singleSelector;
      // eslint-disable-next-line no-underscore-dangle
      this.selectedGigs = this.selectedGigs.filter(item => item !== entry._id);
    }
  }

  ngAfterViewInit(): void {
  }
}
